import React, { useEffect } from 'react'

export default function Input({ object, handleFormData, data, formUse, prefilledData, viewOnly, rowIndex, colIndex }) {

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+ rowIndex +""+ colIndex, "")
    }, [])

    return (
        <div className='d-flex gap-4 align-items-center justify-content-between' style={{ padding: "8px" }}>
            <label>{object.content}</label>
            {/* {data ? <span style={{ width: "60%", fontSize: "12px", color: "gray" }}>{data && data[object?.content]}</span> : <input type='text' style={{ width: "60%" }} className='form-control' onChange={(e) => {
                handleFormData && handleFormData(object.content, e.target.value)
            }}
            />} */}
            {
                prefilledData &&
                    prefilledData[object?.content]
                    ? <span style={{ width: "60%", fontSize: "12px", color: "gray" }}>{prefilledData && prefilledData[object?.content]}</span> :
                    viewOnly ? <span style={{ width: "60%", fontSize: "12px", color: "gray" }}>{data && data[object?.content+"-" +rowIndex+colIndex]}</span> : <input type='text' style={{ width: "60%" }} value={data && data[object?.content+"-"+rowIndex+""+colIndex]} className='form-control' onChange={(e) => {
                        handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, e.target.value)
                    }
                    } />
            }
        </div>
    )
}